import React from "react";
import { Box, Typography, TablePagination } from "@mui/material";
import {
  People as ContactsIcon,
  AddCircleOutlineOutlined,
} from "@mui/icons-material";
import type { VenueContact, IContactData } from "../../types/venues.types";
import { mapVenueContactToContactData } from "../../view-venue/utils/venue.utils";

interface ContactsCardProps {
  contacts: VenueContact[];
  paginatedContacts: VenueContact[];
  contactPage: number;
  contactRowsPerPage: number;
  onPageChange: (event: unknown, newPage: number) => void;
  onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onAddClick: () => void;
  onContactEdit: (updatedContact: IContactData) => void;
  InfoCard: React.ComponentType<{
    title: string;
    icon: React.ReactNode;
    sx?: object;
    actionIcon?: React.ReactNode;
    onActionClick?: () => void;
    children: React.ReactNode;
  }>;
  ContactDetailsDialog: React.ComponentType<{
    contact: IContactData;
    onEdit: (updatedContact: IContactData) => void;
    inline?: boolean;
    showActionsInline?: boolean;
  }>;
}

export const ContactsCard: React.FC<ContactsCardProps> = ({
  contacts,
  paginatedContacts,
  contactPage,
  contactRowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  onAddClick,
  onContactEdit,
  InfoCard,
  ContactDetailsDialog,
}) => {
  return (
    <InfoCard
      title="Contacts"
      sx={{ height: "100%" }}
      icon={<ContactsIcon />}
      actionIcon={<AddCircleOutlineOutlined />}
      onActionClick={onAddClick}
    >
      {contacts.length > 0 ? (
        <>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            {paginatedContacts.map((contact) => (
              <ContactDetailsDialog
                key={contact.id}
                contact={mapVenueContactToContactData(contact)}
                onEdit={onContactEdit}
                inline
                showActionsInline
              />
            ))}
          </Box>

          <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
            <TablePagination
              component="div"
              count={contacts.length}
              page={contactPage}
              onPageChange={onPageChange}
              rowsPerPage={contactRowsPerPage}
              onRowsPerPageChange={onRowsPerPageChange}
              rowsPerPageOptions={[5, 10, 25]}
              sx={{
                "& .MuiToolbar-root": {
                  minHeight: "auto",
                  py: 1,
                },
              }}
            />
          </Box>
        </>
      ) : (
        <Typography variant="subtitle2" gutterBottom>
          No Contacts Available
        </Typography>
      )}
    </InfoCard>
  );
};

export default ContactsCard;
